<script>
    import { onMount } from 'svelte';
    import { user, page, params } from '../stores.js';
    import router from 'page';
    import Home from '../pages/Home.svelte';
	import Logout from '../pages/Logout.svelte';
	import RetrieveFile from '../pages/RetrieveFile.svelte';
	import ShareFile from '../pages/ShareFile.svelte';
	import SharePublic from '../pages/SharePublic.svelte';
	import GenerateLink from '../pages/GenerateLink.svelte';

	//public pages
    router('/', () => $page = Home);
	router('/logout', () => $page = Logout);
	router('/read/:id',
		(ctx, next) => {
			$params = { ...ctx.params };
			next();
		},
		() => $page = RetrieveFile
	);
	router('/respond/:linkId',
		(ctx, next) => {
			$params = { ...ctx.params };
			next();
		},
		() => $page = SharePublic
	);

	//authorized pages
	router('/send', (ctx, next) => {
		if (!isLoggedIn) {
			router.redirect('/');
		}
		else {
			next();
		}
	},
	() => $page = ShareFile);
	router('/request', (ctx, next) => {
		$params = [];

		if (!isLoggedIn) {
			router.redirect('/');
		}
		else {
			next();
		}
	},
	() => $page = GenerateLink);


	let isLoggedIn = false;
	const unsubscribe = user.subscribe(val => {
		isLoggedIn = val != null && typeof(val.name) != 'undefined' && val.name != null;
	});

    onMount(() => router.start());
</script>